import React from "react";
import BookDropDown from "./BookDropDown";
import Header from "./Header";
import TocList from "./TocList";

const LeftPanel = ({ setContent, selectedBook, setSelectedBook, setOpenSideBar }) => {
  return (
    <div id={"leftpanel"} className={`leftpanel`}>
      <Header setOpenSideBar={setOpenSideBar}/>
      <BookDropDown
        selectedBook={selectedBook}
        setSelectedBook={setSelectedBook}
      />
      <TocList book={selectedBook} setContent={setContent} />
    </div>
  );
};

export default LeftPanel;
